<template>

    <transition
        name="fade"
        mode="out-in"
        appear>

        <!-- OVERLAY -->
        <div class="overlay" v-if="!hasEntered" @click.prevent.once="openSesame" :style="{ backgroundColor: cssPropColor('$color-overlay') }">
            <div class="inner">
                <slot></slot>
            </div>
        </div>
        <!-- END OVERLAY -->

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'overlay',

        components: {},

        data() {
            return {

            }
        },

        computed: {

            hasEntered() {
                return this.$dataStore.getters.getEnteredState;
            },

            hasLoaded() {
                return this.$dataStore.getters.getLoadedState;
            }

        },

        created() {

        },

        mounted() {
            vm = this;
        },

        methods: {

            /**
             * @method openSesame
             * @description
             */
            openSesame() {
                if (this.hasLoaded) {
                    gtag('event', 'Enter Experience Click', {
                        'event_category': 'MBRe: Residential',
                        'event_label': ''
                    });

                    this.$dataStore.dispatch('ENTER_INTERACTIVE', { val: !this.$dataStore.state.interactive.entered });
                    this.$eventBus.$emit('residence:transition:in');
                }
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }
        }

    }


</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .overlay {
        background-color: var(--color-overlay);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        animation-duration: 0.3s;
        animation-delay: 0.3s;
        transition: all 0.3s $easeInOutQuad;

        & > .inner {
            height: 100%;
            display: flex;
            justify-content: center;
            transition: all 0.3s $easeInOutQuad;
        }
    }

</style>


// WEBPACK FOOTER //
// Overlay.vue?ecbfb0c4